import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard, FolderKanban, Phone, LogOut, X, ChevronLeft, ChevronRight,
} from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const links = [
  { to: '/admin/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/admin/portfolio', icon: FolderKanban, label: 'Portfolio' },
  { to: '/admin/contact-settings', icon: Phone, label: 'Contact Settings' },
];

const Sidebar = ({ collapsed, onToggle, onMobileClose, mobileOpen }) => {
  const { admin, logout } = useAuth();

  return (
    <>
      {mobileOpen && (
        <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={onMobileClose} />
      )}
      <aside className={`fixed top-0 left-0 z-50 h-full bg-slate-900 text-white transition-all duration-300 flex flex-col 
        ${collapsed ? 'w-16' : 'w-64'} 
        ${mobileOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}>
        <div className={`flex items-center h-16 border-b border-slate-700/50 px-4 ${collapsed ? 'justify-center' : ''}`}>
          {!collapsed && (
            <span className="text-xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
              SkyMuse
            </span>
          )}
          <button onClick={onToggle} className="ml-auto text-slate-400 hover:text-white lg:block hidden">
            {collapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
          </button>
          <button onClick={onMobileClose} className="ml-auto text-slate-400 hover:text-white lg:hidden">
            <X size={20} />
          </button>
        </div>

        <nav className="flex-1 py-4 overflow-y-auto">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              onClick={onMobileClose}
              className={({ isActive }) =>
                `flex items-center ${collapsed ? 'justify-center px-2' : 'px-4'} py-3 mx-2 rounded-lg transition-all 
                ${isActive ? 'bg-purple-600/20 text-purple-400 border-r-2 border-purple-500' : 'text-slate-400 hover:bg-slate-800 hover:text-white'}`
              }
            >
              <link.icon size={20} />
              {!collapsed && <span className="ml-3 text-sm font-medium">{link.label}</span>}
            </NavLink>
          ))}
        </nav>

        <div className={`border-t border-slate-700/50 p-4 ${collapsed ? 'text-center' : ''}`}>
          {!collapsed && (
            <div className="text-xs text-slate-500 mb-2 truncate">{admin?.email}</div>
          )}
          <button
            onClick={() => { logout(); console.log('[Auth] User logged out'); }}
            className={`flex items-center ${collapsed ? 'justify-center' : ''} w-full px-3 py-2 text-sm text-slate-400 hover:text-red-400 hover:bg-red-500/10 rounded-lg transition-all`}
          >
            <LogOut size={18} />
            {!collapsed && <span className="ml-2">Logout</span>}
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
